import {
	ComboBoxControl,
	ComboBoxItemDisplayEnum,
	ComboBoxTypeEnum,
	ContentBlock,
	ContentLoader,
	SelectItemType,
} from '@ukpostbox/frontend-framework';
import { FormProvider, useForm } from '@ukpostbox/frontend-framework/lib/ReactHookForm';
import React, { useEffect } from 'react';
import useTagManager from './Hooks/useTagManager';
import { useMailbox } from '../../../Mailboxes/Providers/NewMailboxProvider';
import { AddTagControlUiType } from './Types/AddTagTypes';

function AddTagControl(props: AddTagControlUiType) {
	const { userFilters, mailItemData, selectedItems } = useMailbox();
	const formMethods = useForm();

	const {
		selectShapedData,
		selectionTags,
		selectionIndeterminateTags,
		tagStatus,
		tagError,

		isRefetchingTag,
		isStaleTag,

		isFetchingNextTagPage,
		fetchNextTagPage,
		hasNextTagPage,
		tagItemCounts,
		CreateTag,
		FilterTags,
	} = useTagManager();

	const HandleCreate = (value: any) => {
		CreateTag(value).then((r) => {
			props.updateCallback({ label: r.name, value: r.id }, true);
		});
	};

	const HandleChange = (e: SelectItemType) => {
		props.updateCallback(e);
	};

	const HandleAllChanged = (e: boolean) => {
		selectShapedData.forEach((tag) => {
			props.updateCallback(tag, e);
		});
	};

	useEffect(() => {
		if (Object.keys(userFilters).length > 0) {
			FilterTags(mailItemData, [mailItemData?.mailUuid]);
		} else {
			FilterTags(props.data, selectedItems);
		}
	}, [props, userFilters]);

	return tagStatus === 'pending' ? (
		<ContentLoader />
	) : tagStatus === 'error' ? (
		<ContentBlock error title={tagError?.name as string} content={tagError?.message} />
	) : (
		<FormProvider {...formMethods}>
			<ComboBoxControl
				name='addTags'
				placeholder='Filter Tags...'
				data={selectShapedData}
				forwardItemCallback={(e) => HandleChange(e)}
				forwardSelectAllCallback={(e) => HandleAllChanged(e)}
				defaultValue={selectionTags}
				indeterminateValues={selectionIndeterminateTags}
				loading={selectShapedData.length === 0}
				listAlwaysVisible={props.listAlwaysVisible}
				valueType='number'
				listInMenu={props.listInMenu}
				pagination={{
					hasNextPage: hasNextTagPage,
					itemCounts: tagItemCounts,
					isStale: isStaleTag,
					isRefetching: isRefetchingTag,
					isFetchingNextPage: isFetchingNextTagPage,
					fetchNextPage: fetchNextTagPage,
				}}
				hideArrow
				emptyResultCallback={(value: any) => HandleCreate(value)}
				autoFocusFilter
				clearOnClose
				displayType={ComboBoxTypeEnum.Multi}
				displayItemLabelType={ComboBoxItemDisplayEnum.Label}
			/>
		</FormProvider>
	);
}

export default AddTagControl;
